module.exports = __webpack_public_path__ + "static/media/cross.a594ab60.svg";